import React, { useEffect, useState, useRef } from "react";
import { Panel, Text } from "rsuite";
import { Button, Input, notification } from "antd";
import { useParams } from "react-router-dom";
import {
  getGruposLab,
  getListMarcadoresLab,
} from "../Services/CatalogosServices";
import {
  getResultLabsPaciente,
  getGruposLabHistorico,
  getSpConsultaLabHistorico,
  addMarcador,
} from "../Services/ConsultasServices";

export const Laboratorios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [showFilaEdit, setShowFilaEdit] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>> PARAMETROS DE ESTADO PARA EL COMPONENTE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  const [dataGrupos, setDataGrupos] = useState([]);
  const [dataMarcadores, setDataMarcadores] = useState([]);
  const [dataResultados, setDataResultados] = useState([]);

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>> PARAMETROS DE ESTADO PARA EL COMPONENTE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  const [dataGruposHistorico, setDataGruposHistorico] = useState([]);
  const [dataMarcadoresHistorico, setDataMarcadoresHistorico] = useState([]);
  const [dataResultadosHistorico, setDataResultadosHistorico] = useState([]);

  const [idGpo, setidGpo] = useState("");
  const [idMarcador, setIdMarcador] = useState("");
  const [marcador, setMarcador] = useState("");
  const [valor, setValor] = useState("");
  const { idPaciente, paciente } = useParams();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const fetchGruposLab = async () => {
    try {
      const response = await getGruposLab(idNegocio);
      setDataGrupos(response);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchListaMarcadoresLab = async () => {
    try {
      const response = await getListMarcadoresLab(idNegocio);
      setDataMarcadores(response);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchResultadosLaboratorio = async () => {
    try {
      const response = await getResultLabsPaciente(
        idNegocio,
        idMedico,
        idPaciente,
      );
      setDataResultados(response);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchGruposHistorico = async () => {
    try {
      const response = await getGruposLabHistorico(idNegocio, idPaciente);
      setDataGruposHistorico(response);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchListaMarcadoresHistorico = async () => {
    try {
      const response = await getSpConsultaLabHistorico(idNegocio, idPaciente);
      const groupedValues = response.map((item) => Object.keys(item));
      setDataMarcadoresHistorico(groupedValues);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchResultadosHistorico = async () => {
    try {
      const response = await getSpConsultaLabHistorico(idNegocio, idPaciente);
      const groupedValues = response.map((item) => Object.values(item));
      setDataResultadosHistorico(groupedValues);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const handleEditar = (idGpo, idMarcador, marcador, valor) => {
    setShowFilaEdit(true);
    setidGpo(idGpo);
    setIdMarcador(idMarcador);
    setMarcador(marcador);
    setValor(valor);
  };

  const saveMarcador = async () => {
    const data = {
      IdConsultorio: idNegocio,
      IdConsulta: 0,
      IdGpo: idGpo,
      IdMarcador: idMarcador,
      Valor: valor,
      IdMedico: idMedico,
      IdPaciente: idPaciente,
    };

    await addMarcador(data)
      .then((res) => {
        if (res.data > 0) {
          successNotification(
            "Marcador",
            "Se guardo el valor del laboratorio.",
          );
          fetchResultadosLaboratorio();
          setShowFilaEdit(false);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleFocus = (event) => event.target.select();

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchGruposLab().then(() => {
        fetchListaMarcadoresLab().then(() => {
          fetchResultadosLaboratorio().then(() => {
            fetchGruposHistorico().then(() => {
              fetchListaMarcadoresHistorico().then(() => {
                fetchResultadosHistorico();
              });
            });
          });
        });
      });
    }
  }, []);

  return (
    <>
      <title>Consulta / Laboratorios</title>
      <div style={{ padding: "20px" }}>
        {contextHolder}
        <Panel
          header={
            <Text weight="semibold" size="xl">
              Consulta - Paciente: {paciente} <br></br> Laboratorios
            </Text>
          }
          bordered
        >
          <div>
            <div className="overflow-hidden rounded-md border border-gray-200 shadow-sm">
              <table className="w-full text-left text-sm text-gray-600">
                <thead className="bg-gray-100 text-xs uppercase text-gray-700">
                  <tr>
                    {dataGrupos.map((grupo) => (
                      <th
                        colSpan={grupo.marcadores}
                        className="px-6 py-3 font-semibold"
                      >
                        {grupo.label}
                      </th>
                    ))}
                  </tr>
                  <tr style={{ height: "30px" }}>
                    {dataMarcadores.map((marcador) => (
                      <td
                        style={{
                          fontSize: "13px",
                          textAlign: "center",
                          fontWeight: "500",
                          border: "1px solid lightgray",
                        }}
                      >
                        {marcador.marcador}
                      </td>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  <tr className="hover:bg-gray-50 transition-colors">
                    {dataResultados.map((resultado) => (
                      <td
                        style={{
                          fontSize: "13px",
                          textAlign: "center",
                          border: "1px solid lightgray",
                        }}
                      >
                        <Button
                          block
                          variant="text"
                          color="default"
                          size="small"
                          onClick={() =>
                            handleEditar(
                              resultado.idGpo,
                              resultado.idMarcador,
                              resultado.marcador,
                              resultado.valor,
                            )
                          }
                        >
                          {resultado.valorFinal}
                        </Button>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
            {showFilaEdit && (
              <Panel
                header={<Text weight="semibold">Editar Resultado</Text>}
                bordered
                style={{ backgroundColor: "#f5f5f5", padding: "10px" }}
              >
                <div className="row mb-3">
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <Text weight="semibold">Marcador</Text>
                    <Input readOnly value={marcador} />
                  </div>
                  <div className="text-center col-lg-1 col-md-1 col-sm-1">
                    <Text weight="semibold">Valor</Text>
                    <Input
                      value={valor}
                      style={{ textAlign: "center" }}
                      onChange={(e) => setValor(e.target.value)}
                      onFocus={handleFocus}
                      onClick={handleFocus}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-2 col-sm-2"
                    style={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={saveMarcador}
                    >
                      Guardar
                    </Button>
                  </div>
                </div>
              </Panel>
            )}
          </div>
        </Panel>
        <Panel
          header={<Text weight="semibold">Historico de Laboratorios</Text>}
          bordered
          style={{ marginTop: "5px" }}
        >
          <div className="overflow-hidden rounded-md border border-gray-200 shadow-sm">
            <table className="w-full text-left text-sm text-gray-600">
              <thead className="bg-gray-100 text-xs uppercase text-gray-700">
                <tr>
                  <th></th>
                  {dataGrupos.map((grupo) => (
                    <th
                      colSpan={grupo.marcadores}
                      style={{ fontSize: "14px", textAlign: "center" }}
                    >
                      {grupo.label}
                    </th>
                  ))}
                </tr>
                {dataMarcadoresHistorico.map((item, ix) =>
                  ix === 0 ? (
                    <tr>
                      {item.map((marcador, index) => (
                        <td
                          key={`marcador-${ix}-${index}`}
                          style={{
                            fontSize: "13px",
                            textAlign: "center",
                            fontWeight: "500",
                          }}
                        >
                          {marcador.toUpperCase()}
                        </td>
                      ))}
                    </tr>
                  ) : null,
                )}
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {dataResultadosHistorico.map((item, ix) => (
                  <tr>
                    {item.map((valor, index) => (
                      <td
                        key={`valor-${ix}-${index}`}
                        style={{ fontSize: "13px", textAlign: "center" }}
                      >
                        {index === 0
                          ? valor.substring(0, 10)
                          : valor === -1
                            ? "NEG"
                            : valor}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </>
  );
};
